import { handleActions } from 'redux-actions';
import { defaultPersonalInformationWidgetState } from './defaults';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  saveableWidgetRequestMetaReducer,
  INITIAL_SAVE_REQUEST_META,
} from '../utils';
import { PersonalInformationWidgetData } from '../../widgets/personalInformation/types';
import { initMyAccountPage } from '../../actions';
import {
  setPersonalInformationWidgetCountryId,
  setPersonalInformationWidgetBirthday,
  setPersonalInformationWidgetPronoun,
  setPersonalInformationWidgetBirthdayDisplay,
  setPersonalInformationWidgetShowPronoun,
  submitChangeDateOfBirthModal,
  savePersonalInformation,
  savePersonalInformationSuccess,
  savePersonalInformationFailure,
  setPersonalInformationWidgetMeasurements,
  submitChangeDateOfBirthModalSuccess,
} from './actions';

const mergePersonalInformationWidgetDataChange = makeSpecificSaveableWidgetDataMergeFunction(
  defaultPersonalInformationWidgetState
);

export default handleActions<PersonalInformationWidgetData, any>(
  {
    [initMyAccountPage.toString()]: (state, action: ReturnType<typeof initMyAccountPage>) => {
      const personalInformationData: PersonalInformationWidgetData['initialData'] = {
        pronoun: action.payload.data.pronoun,
        showPronoun: action.payload.data.showPronoun,
        birthday: action.payload.data.birthday,
        countryId: action.payload.data.countryId,
        countries: action.payload.data.countries,
        measurements: action.payload.data.measurements,
        canUpdateEmail: action.payload.data.canUpdateEmail,
      };
      return {
        initialData: personalInformationData,
        currentData: personalInformationData,
        isDirty: false,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setPersonalInformationWidgetCountryId.toString()]: (
      state,
      action: ReturnType<typeof setPersonalInformationWidgetCountryId>
    ) =>
      mergePersonalInformationWidgetDataChange(state, {
        countryId: action.payload.countryId,
      }),
    [setPersonalInformationWidgetPronoun.toString()]: (
      state,
      action: ReturnType<typeof setPersonalInformationWidgetPronoun>
    ) =>
      mergePersonalInformationWidgetDataChange(state, {
        pronoun: action.payload.pronoun,
      }),
    [setPersonalInformationWidgetShowPronoun.toString()]: (
      state,
      action: ReturnType<typeof setPersonalInformationWidgetShowPronoun>
    ) =>
      mergePersonalInformationWidgetDataChange(state, {
        showPronoun: action.payload.showPronoun,
      }),
    [setPersonalInformationWidgetBirthday.toString()]: (
      state,
      action: ReturnType<typeof setPersonalInformationWidgetBirthday>
    ) =>
      mergePersonalInformationWidgetDataChange(state, {
        birthday: {
          ...state.currentData.birthday,
          dateOfBirth: action.payload.birthday,
        },
      }),
    [setPersonalInformationWidgetBirthdayDisplay.toString()]: (
      state,
      action: ReturnType<typeof setPersonalInformationWidgetBirthdayDisplay>
    ) =>
      mergePersonalInformationWidgetDataChange(state, {
        birthday: {
          ...state.currentData.birthday,
          display: action.payload.birthdayDisplay,
        },
      }),
    [setPersonalInformationWidgetMeasurements.toString()]: (
      state,
      action: ReturnType<typeof setPersonalInformationWidgetMeasurements>
    ) =>
      mergePersonalInformationWidgetDataChange(state, {
        measurements: action.payload.measurements,
      }),
    [submitChangeDateOfBirthModal.toString()]: (
      state,
      action: ReturnType<typeof submitChangeDateOfBirthModal>
    ) =>
      mergePersonalInformationWidgetDataChange(state, {
        birthday: {
          ...state.currentData.birthday,
          dateOfBirth: new Date(
            Date.UTC(action.payload.year, action.payload.month, action.payload.day)
          ).toISOString(),
        },
      }),
    [submitChangeDateOfBirthModalSuccess.toString()]: (
      state,
      action: ReturnType<typeof submitChangeDateOfBirthModalSuccess>
    ) => {
      // We've got to get a bit wacky with the state merge here since DOB can be saved separately from the rest of the widget
      const stateWithUpdatedInitialData = {
        ...state,
        initialData: {
          ...state.initialData,
          birthday: {
            ...state.initialData.birthday,
            dateOfBirth: action.payload.dateOfBirth,
            canChange: false,
          },
        },
      };
      return mergePersonalInformationWidgetDataChange(stateWithUpdatedInitialData, {
        birthday: {
          ...state.currentData.birthday,
          dateOfBirth: action.payload.dateOfBirth,
          canChange: false,
        },
      });
    },
    ...saveableWidgetRequestMetaReducer({
      initialAction: savePersonalInformation,
      successAction: savePersonalInformationSuccess,
      failureAction: savePersonalInformationFailure,
    }),
  },

  defaultPersonalInformationWidgetState
);
